import React from "react";
import "./SlotGamesDevelopmentProcessStyle.scss";
import { slotGamesDevelopmentProcessTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";

const SlotGamesDevelopmentProcessSection = () => {
  return (
    <section className="slot-games-development-process-section">
      <div className="slot-games-development-process-wrap">
        <SectionHeading>
          {slotGamesDevelopmentProcessTextContent.headingText}
        </SectionHeading>

        <div className="slot-games-development-process-box">
          <div className="cards-grid">
            {slotGamesDevelopmentProcessTextContent.content.map(
              (section, index) => (
                <div className="card" key={index}>
                  <div className="card-header">
                    <div className="icon-box">
                      <img src={section.iconSrc} alt="Image" />
                    </div>
                    <h5 className="title-text">{section.titleText}</h5>
                  </div>
                </div>
              )
            )}
          </div>
          
          <div className="cards-grid">
            {slotGamesDevelopmentProcessTextContent.content.map(
              (section, index) => (
                <div className="card" key={index}>
                  <div className="card-header">
                    <div className="icon-box">
                      <img src={section.iconSrc} alt="Image" />
                    </div>
                    <h5 className="title-text">{section.titleText}</h5>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlotGamesDevelopmentProcessSection;
